var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentStrike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c92a1d",
    fillRule: "nonzero",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.853 23.982l-3.354-9.388h6.226L9.14 1.766H2.871l3.355 9.388H0l10.853 12.828zM31.309 9.961L26.76 6.613V2.621c0-.625-.508-1.133-1.134-1.133h-1.84c-.625 0-1.133.508-1.133 1.133v.971l-3.468-2.555c-.753-.553-1.984-.553-2.739 0l-5.123 3.771L12.67 8.74l3.776-2.779c.755-.555 1.986-.555 2.739 0l9.774 7.193.335-.457a1.701 1.701 0 01-2.375 0l4.39-2.736z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.69 13.781l-8.501-6.283v.004l-.007-.004c-.753-.555-1.98-.555-2.733 0l-3.355 2.48 1.842 5.377H8.803l2.769 9.873-4.988-4.877v4.346c0 1.48 1.269 2.68 2.831 2.68h5.193v-8.055c0-.625.509-1.135 1.132-1.135h4.153c.623 0 1.132.51 1.132 1.135v8.055h5.201c1.563 0 2.832-1.199 2.832-2.678v-9.112c-.001-.437-.617-1.249-1.368-1.806h0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentStrike);
export default __webpack_public_path__ + "static/media/rent-strike.60dfe7e153cae12ebaedcadcf930316f.svg";
export { ForwardRef as ReactComponent };